/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "FailPlaidLinkRequest": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "reason": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "FailPlaidLinkResponse": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.FailPlaidLinkRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.FailPlaidLinkResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FailPlaidLinkRequest @ squareup/sfs/external/services/external_bank_account/fail_plaid_link.proto at 8:1
 */
export const FailPlaidLinkRequest = $root.lookupType('squareup.sfs.external.service.FailPlaidLinkRequest');
fixType(FailPlaidLinkRequest, {
  customerId: {
    required: true
  },
  reason: {
    required: true
  }
});
Builder.createAndAttachToType(FailPlaidLinkRequest);
/**
 * SOURCE FailPlaidLinkResponse @ squareup/sfs/external/services/external_bank_account/fail_plaid_link.proto at 22:1
 */
export const FailPlaidLinkResponse = $root.lookupType('squareup.sfs.external.service.FailPlaidLinkResponse');
fixType(FailPlaidLinkResponse);
Builder.createAndAttachToType(FailPlaidLinkResponse);